import { useContext, useEffect, useState } from "react";
import { MainContext } from "../App";
import CloseIcon from "../icons/CloseIcon";

function PriceEditPopup() {
  const { user, cart, setCart, popupData, setPopupVisible } = useContext(MainContext);
  const isAdmin = parseInt(user?.role?.admin) === 1;
  const canEditPrices = isAdmin || parseInt(user?.role?.waiter_permissions?.prices_edit?.edit) === 1;
  const productIndex = popupData?.index;
  const product = cart?.products?.[productIndex];
  const [value, setValue] = useState("");

  useEffect(() => {
    if (!product) return;
    const initial = String(product.price ?? "").replace(",", ".");
    setValue(initial);
  }, [product]);

  const append = (token) => {
    const char = token === "," ? "." : token;
    if (char === "." && value.includes(".")) return;
    if (char === ".") {
      setValue(value.length === 0 ? "0." : value + ".");
      return;
    }
    setValue(value + char);
  };

  const backspace = () => {
    if (value.length === 0) return;
    setValue(value.slice(0, -1));
  };

  const clear = () => setValue("");

  const confirm = () => {
    const normalized = value.replace(",", ".");
    const parsed = parseFloat(normalized);
    if (isNaN(parsed) || parsed < 0) return;
    let tempCart = { ...cart, products: [...cart.products] };
    tempCart.products[productIndex] = {
      ...tempCart.products[productIndex],
      price: parsed.toFixed(2),
    };
    setCart(tempCart);
    setPopupVisible(false);
  };

  if (!canEditPrices || !product) return null;

  return (
    <div className="popup popup-small">
      <div className="container">
        <header>
          <div className="buttons-group">
            <button className="btn btn-tertiary btn-square" onClick={() => setPopupVisible(false)}>
              <CloseIcon />
            </button>
            <div>Modifica prezzo</div>
          </div>
        </header>
        <div className="content">
          <div className="text-box">
            {product.name}
          </div>
          <div className="price-editor-display">{value.length > 0 ? value.replace(".", ",") : "0,00"}</div>
          <div className="price-keypad">
            <button onClick={() => append("1")}>1</button>
            <button onClick={() => append("2")}>2</button>
            <button onClick={() => append("3")}>3</button>
            <button onClick={() => append("4")}>4</button>
            <button onClick={() => append("5")}>5</button>
            <button onClick={() => append("6")}>6</button>
            <button onClick={() => append("7")}>7</button>
            <button onClick={() => append("8")}>8</button>
            <button onClick={() => append("9")}>9</button>
            <button onClick={clear}>C</button>
            <button onClick={() => append("0")}>0</button>
            <button onClick={() => append(",")}>,</button>
          </div>
          <div className="buttons-group full">
            <button className="btn btn-tertiary btn-block" onClick={backspace}>
              Cancella
            </button>
            <button className="btn btn-secondary btn-block" onClick={confirm}>
              Conferma
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PriceEditPopup;
